export interface IAdminGroup {
  id: number;
  club: number;
  name: string;
  description: string;
  members: number[];
}

export interface IAdminGroupsStore {
  groups: IAdminGroup[];
}

export const adminGroupsStore: IAdminGroupsStore = {
  groups: []
};
